var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayerPopup',{attrs:{"popId":'loading'},scopedSlots:_vm._u([{key:"popContents",fn:function(){return [_c('div',{staticClass:"loading_cirlce"})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }